const REQUEST_REPORT_DATA = '@@statsReport/REQUEST_REPORT_DATA';
const REPORT_DATA_RESPONSE = '@@statsReport/REPORT_DATA_RESPONSE';

const REQUEST_COUNTRY = '@@statsReport/REQUEST_COUNTRY';
const COUNTRY_RESPONSE = '@@statsReport/COUNTRY_RESPONSE';

const REQUEST_FRANCHISE = '@@statsReport/REQUEST_FRANCHISE';
const FRANCHISE_RESPONSE = '@@statsReport/FRANCHISE_RESPONSE';

export default {
    REQUEST_REPORT_DATA,
    REPORT_DATA_RESPONSE,
    REQUEST_COUNTRY,
    COUNTRY_RESPONSE,
    REQUEST_FRANCHISE,
    FRANCHISE_RESPONSE,
};